import { CodeSelect } from '../Common/CodeSelect';
import TopMenu from '../Common/TopMenu';
import React, { useState, useEffect, useContext } from 'react';
import axios from '../Common/axios';
import dayjs from 'dayjs';
import AppContext from '../../components/AppContext';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Button, Tag, InputNumber, Input, Modal, DatePicker, Card, TimePicker, Col, Row } from "antd";
import { getCompanyConfig, getMyPermissions } from '../Common/api';
import {useConfigValue} from '../ConfigValue/configData';
import Cookies from 'js-cookie';
import { getCodeList } from '../Common/codeManager';

function ConfigValue() {
    const myContext = useContext(AppContext);
    const {fetchAndUpdateConfig, updateCompanyConfig} = useConfigValue();
    // 쿠키에서 인증 토큰 값 가져오기
    const authToken = Cookies.get('access_token');
    // 인증 토큰 값이 존재하면 로그인된 상태로 처리
    const authenticated = authToken ? true : false;
    const [companyCode, setCompanyCode] = useState(myContext.companyCode);
    const [companyName, setCompanyName] = useState(myContext.companyName);
    const [riskGrdHigh, setRiskGrdHigh] = useState(myContext.riskGrdHigh);  //12이상이면 High
    const [riskGrdRow, setRiskGrdRow] = useState(myContext.riskGrdLow);  //12이  //5이하이면 Row
    const [assetGradeHigh, setAssetGradeHigh] = useState(myContext.assetGradeHigh);  //7이상이면 High
    const [assetGradeRow, setAssetGradeRow] = useState(myContext.assetGradeRow);
    const [doa, setDoa] = useState(myContext.doa);
    const [appVersion,setAppVersion] = useState("");
    const [appUrl, setAppUrl] = useState("");
    const [appAutoDate, setAppAutoDate] = useState("");
    const [licenseDate, setLicenseDate] = useState("");
    const [pcLimit, setPcLimit] = useState("");
    const [pcUsed, setPcUsed] = useState("");
    const [serverLimit, setServerLimit] = useState("");
    const [serverUsed, setServerUsed] = useState("");
    // const [appAutoHour, setAppAutoHour] = useState("");
    // const [appAutoMinu, setAppAutoMinu] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [permissions, setPermissions] = useState(null);
    const titleName = "보고서 상세";

    useEffect(() => {
        // 코드 목록 새로고침
        getCodeList();
        
        if (companyCode) {
            findConfigValue();
        }
        fetchPermissions();
    }, [companyCode]);

    const convertToUnixTime = (date, hour, minu) => {
        const dateTime = `${date} ${hour}:${minu}:00`;
        return Math.floor(new Date(dateTime).getTime()/1000);
    };

    const fetchPermissions = async () => {
        try {
            const response = await axios.get(getMyPermissions());
            
            if (response.data) {
                setPermissions(response.data);
            }
        } catch (error) {
            console.error("권한 정보 조회 실패:", error);
        }
    };

    const findConfigValue = async () => {
        try {
            const configFlag = await fetchAndUpdateConfig(companyCode);

            if (configFlag !== false) {
                setAssetGradeHigh(configFlag.val_01);
                setAssetGradeRow(configFlag.val_02);
                
                setRiskGrdHigh(configFlag.val_03);
                setRiskGrdRow(configFlag.val_04);
        
                setDoa(configFlag.val_10);
                setCompanyCode(configFlag.code_cd);
                setCompanyName(configFlag.code_nm);

                setLicenseDate(configFlag.get_license_date);
                setPcLimit(configFlag.get_pc_limit);
                setPcUsed(configFlag.get_pc_used);
                setServerLimit(configFlag.get_server_limit);
                setServerUsed(configFlag.get_server_used);
                
                if(configFlag.val_05){
                    const [ClicenseDate="0", CpcLimit="0", CpcUsed="0", CserverLimit="0", CserverUsed="0"] = configFlag.val_05.split(",");
                        
                    setLicenseDate(ClicenseDate);
                    setPcLimit(CpcLimit);
                    setPcUsed(CpcUsed); 
                    setServerLimit(CserverLimit);
                    setServerUsed(CserverUsed);
                }else{
                    setLicenseDate("0");
                    setPcLimit("0");
                    setPcUsed("0");
                    setServerLimit("0");
                    setServerUsed("0");
                }

                if(configFlag.val_07){
                    configFlag.val_07.split(",").map((item, index) => {
                        if(index === 0){
                            setAppVersion(item);
                        }else if(index === 1){
                            setAppUrl(item);
                        }else if(index === 2){
                            // const appAutoDates = convertUnixTime(item);
                            // setAppAutoDate(appAutoDates.date);
                            // setAppAutoHour(appAutoDates.hour);
                            // setAppAutoMinu(appAutoDates.minu);
                            // setAppAutoDate(dayjs(new Date(item)).format('YYYY-MM-DD HH:mm:ss'));
                            // setAppAutoDate(dayjs(new Date(item)));
                            setAppAutoDate(item*1000);
                        }
                    });      
                }else{
                    setAppVersion("");
                    setAppUrl("");
                    setAppAutoDate("");
                }
            }
        } catch (error) {
            console.error("Dashboard initialization error:", error);
        }        
    }

    // const requestData = (response)=>{
    //     console.dir(myContext);
    //     console.log("-----------");
    //     myContext.setAssetGradeHigh(response.data.val_01);
    //     myContext.setAssetGradeRow(response.data.val_02);
        
    //     myContext.setRiskGrdHigh(response.data.val_03);
    //     myContext.setRiskGrdRow(response.data.val_04);

    //     myContext.setDoa(response.data.val_10);
    //     myContext.setCompanyCode(response.data.code_cd);
    //     myContext.setCompanyName(response.data.code_nm);

        // setAssetGradeHigh(response.data.val_01);
        // setAssetGradeRow(response.data.val_02);
        
        // setRiskGrdHigh(response.data.val_03);
        // setRiskGrdRow(response.data.val_04);

        // setDoa(response.data.val_10);
        // setCompanyCode(response.data.code_cd);
        // setCompanyName(response.data.code_nm);   
    // }

    // const findConfigValue = () => {
    //     //자산유형별 최종 레포트ID조회 => 진단항목별 보안수준 현황
    //     axios.get(getCompanyConfig(companyCode))
    //     .then((response) => {
    //         requestData(response);          
    //     })
    //     .catch((error) => {
    //         Modal.error({
    //             title: "페이지 로딩중에 오류가 발생했습니다.", okText: "Close"
    //         });
    //     });
    // }

    const onClickConfigMod = (param) => {
        
        validateCompany();
        const reqData={};
        let reqTitle="";

        if(param === "asset"){
            reqData.val_01=parseInt(assetGradeHigh);
            reqData.val_02=parseInt(assetGradeRow);
            reqTitle="보안등급";
            if(reqData.val_01 <= reqData.val_02){
                Modal.info({
                    title: reqTitle+"에 범위가 잘못되었습니다.", okText: "Close"
                });       
                return;         
            }
        }else if(param === "risk"){
            reqData.val_03=parseInt(riskGrdHigh);
            reqData.val_04=parseInt(riskGrdRow);
            reqTitle="위험등급";
            if(reqData.val_03 <= reqData.val_04){
                Modal.info({
                    title: reqTitle+"에 범위가 잘못되었습니다.", okText: "Close"
                });            
                return;    
            }
        }else if(param === "doa"){
            reqData.val_10=parseInt(doa);
            reqTitle="DOA";
        }else if(param === "auto"){
            const isoTimeStr = Date.parse(new Date(appAutoDate).toISOString());
            reqData.val_07 = appVersion+","+appUrl+","+ Math.floor(isoTimeStr/1000);
            // reqData.val_07 = appVersion+","+appUrl+","+ isoTimeStr;
            // reqData.val_24 = convertToUnixTime(appAutoDate, appAutoHour, appAutoMinu);
            // alert(reqData.val_07);
            reqTitle = "진단 예약 설정";
        }else{
            alert("알수 없는 설정값 입니다. 새로고침하거나 로그아웃 후 다시 로그인 해주세요.");
            return;
        }

        axios.patch(getCompanyConfig(companyCode), reqData )
        .then((response) => {
            if(response.data.id){
                updateCompanyConfig(response.data);                
                Modal.info({
                    title: reqTitle+"값이 수정되었습니다.", okText: "Close"
                });
            }else{        
                Modal.error({
                    title: reqTitle+"값이 수정중에 오류가 발생했습니다.", content:response.data.message, okText: "Close"
                });
            }
        })
        .catch((error) => {   
            Modal.error({
                title: reqTitle+"값이 수정중에 오류가 발생했습니다.", content:error.response.data.message, okText: "Close"
            });
        });
    }

    const menualPopup = (e) => {
        e.preventDefault();
        e.stopPropagation();
        // 팝업 window의 크기 지정
        const width = 700;
        const height = 850;

        // 팝업을 부모 브라우저의 정 중앙에 나열
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;
        const windowOptions = `width=${width},height=${height},left=${left},top=${top},scrollbars=1`;
        const dataValue = e.currentTarget.getAttribute("data");
        let url = "";

        if (dataValue === "rl") {
            url = "/pdf/rms_risk.pdf";
        } else {
            url = "/pdf/rms_secure.pdf";
        }

        window.open(url, "popupWindow", windowOptions);
    }

    const validateCompany = () => {
        // 필수조건 체크
        if (companyCode == '') {
            Modal.info({ title: "회사명이 누락되었습니다.", okText: "Close" });
            return;
        }
    }

    const onChangeCompanyCode = (value, option) => {
        setCompanyCode(value);
        setCompanyName(option.children[2]);
        myContext.setCompanyCode(value);
        myContext.setCompanyName(option.children[2]);
    };

    const onDateChange = (date, dateString) => {
        if (date) {
            setAppAutoDate(date);
            // setAppAutoDate(date.format('YYYY-MM-DD HH:mm:ss'));
        } else {
            setAppAutoDate(null);
        }
    };

    const onHourChange = (time, timeString) => {
        if (time) {
            setAppAutoHour(time.format('HH'));
        } else {
            setAppAutoHour(null);
        }
    };

    const onMinuChange = (time, timeString) => {
        if (time) {
            setAppAutoMinu(time.format('mm'));
        } else {
            setAppAutoMinu(null);
        }
    };

    const options = [
        {
          value: 'Y',
          label: ' 사용 ',
        },
        {
          value: 'N',
          label: '미사용',
        },
    ];

    return (
        <>
            <TopMenu selectKey='config' />
            <table><tbody><tr><td style={{display:"block", maxHeight:"calc(90vh - 20px)", overflow:"auto"}}>
                <div className="section">
                    <table className='search'>
                        <colgroup>
                            <col style={{ width: '120px' }} />
                            <col style={{ width: '300px' }} />
                            <col style={{ width: '700px' }} />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th><span className='req'>*</span>회사</th>
                                <td>
                                    <CodeSelect codeType="com_cd"
                                        id="companyCode"
                                        value={companyCode}
                                        disabled={authenticated ? true : false}
                                        onChangeHandler={onChangeCompanyCode}
                                        key={1}
                                    />
                                </td>
                                <td>&nbsp;</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* <div className="section">
                    <table className='search_config' style={{position: "relative", left: "20px", width: "900px" }}>
                        <tr><td>
                            <div style={{ position: "relative", fontSize: "16px", left: "20px", top: "10px" }}>
                            라이센스 정보
                            </div>
                        </td></tr>
                        <tr><td>
                            <Row gutter={12}>
                                <Card title="라이센스 만료일" type="inner" style={{width: "160px", marginRight: "12px" }}>
                                    {licenseDate}
                                </Card>
                                <Card title="점검 혀용된 PC 수" type="inner" style={{width: "160px", marginRight: "12px" }}>
                                    {pcLimit} ea
                                </Card>
                                <Card title="점검된 PC 수" type="inner" style={{width: "160px", marginRight: "12px" }}>
                                    {pcUsed} ea
                                </Card>
                                <Card title="점검 혀용된 서버 수" type="inner" style={{width: "160px", marginRight: "12px" }}>
                                    {serverLimit} ea
                                </Card>
                                <Card title="점검된 서버 수" type="inner" style={{width: "160px", marginRight: "12px" }}>
                                    {serverUsed} ea
                                </Card>
                            </Row>
                    </td></tr>
                    </table>
                </div> */}

                <div className="section">
                    <table className='search_config' style={{ position: "relative", left: "60px", backgroundColor: "white", width: "650px" }}>
                        <colgroup>
                            <col style={{ width: '120px' }} />
                            <col style={{ width: '380px' }} />
                            <col style={{ width: '100px' }} />
                        </colgroup>
                        <tbody>
                            {/* <tr>
                            <th style={{backgroundColor:'white', textAlign:"left"}}><span className='req'>*</span>회 사</th>
                            <td colSpan={2} >
                                <CodeSelect codeType="com_cd" 
                                            id="companyCode"
                                            value={companyCode}
                                            disabled={true}
                                            onChangeHandler={onChangeCompanyCode}
                                />
                            </td>
                        </tr> */}
                            <tr>
                                <td colSpan={3}>
                                    <div style={{ position: "relative", fontSize: "16px", left: "-12px", top: "10px" }}>
                                        자산 중요도 기준 &nbsp;
                                        <a href="#" data="sl" onClick={menualPopup}><QuestionCircleOutlined /></a>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th style={{ backgroundColor: 'white', textAlign: "left" }}>
                                    <span className='req'>*</span>보안등급
                                </th>
                                <td>
                                    &nbsp;&nbsp;&nbsp;
                                    <Tag color={'volcano'}>High</Tag>
                                    <InputNumber min={3} max={9} value={assetGradeHigh} size={'small'} style={{ width: '50px' }} onChange={(value) => { setAssetGradeHigh(value) }} /> 이상
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <Tag color={'green'}>Low</Tag>
                                    <InputNumber min={3} max={9} value={assetGradeRow} size={'small'} style={{ width: '50px' }} onChange={(value) => { setAssetGradeRow(value) }} /> 이하
                                    {/* <p style={{ color: '#0378c7', padding: "0", margin: "4px 0 0 0" }}>
                                        &nbsp;&nbsp; 위혐등급에 대한 자세한 설명은 물음표 버튼을 클릭해서 확인.
                                    </p> */}


                                </td><td>
                                    <Button type="primary" onClick={() => onClickConfigMod("asset")}loading={isLoading}>
                                        보안등급 설정
                                    </Button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="section">
                    <table className='search_config' style={{ position: "relative", left: "60px", backgroundColor: "white", width: "650px" }}>
                        <colgroup>
                            <col style={{ width: '120px' }} />
                            <col style={{ width: '380px' }} />
                            <col style={{ width: '100px' }} />
                        </colgroup>
                        <tbody>
                            <tr>
                                <td colSpan={3}>
                                    <div style={{ position: "relative", fontSize: "16px", left: "-12px", top: "10px" }}>
                                        위험도 기준 &nbsp;
                                        <a href="#" data="rl" onClick={menualPopup}><QuestionCircleOutlined /></a>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th style={{ backgroundColor: 'white', textAlign: "left" }}>
                                    <span className='req'>*</span>위험등급
                                </th>
                                <td>

                                    &nbsp;&nbsp;&nbsp;
                                    <Tag color={'volcano'}>High</Tag>
                                    <InputNumber min={1} max={27} value={riskGrdHigh} size={'small'} style={{ width: '50px' }} onChange={(value) => { setRiskGrdHigh(value); }} /> 이상
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <Tag color={'green'}>Low</Tag>
                                    <InputNumber min={1} max={27} value={riskGrdRow} size={'small'} style={{ width: '50px' }} onChange={(value) => { setRiskGrdRow(value); }} /> 미만
                                    {/* <p style={{ color: '#0378c7', padding: "0", margin: "4px 0 0 0" }}>
                                        &nbsp;&nbsp; 보안등급에 대한 자세한 설명은 물음표 버튼을 클릭해서 확인.
                                    </p> */}
                                </td><td>
                                    <Button type="primary" onClick={() => onClickConfigMod("risk")} loading={isLoading} >
                                        위험등급 설정
                                    </Button>
                                </td>
                            </tr>
                            <tr>
                                <th style={{ backgroundColor: 'white', textAlign: "left" }}><span className='req'>*</span>DOA 기준</th>
                                <td>
                                    &nbsp;&nbsp;&nbsp;
                                    <Tag color={'volcano'}>DOA</Tag> 
                                    <InputNumber min={1} max={27} value={doa} size={'small'} style={{ width: '50px' }} onChange={(value) => { setDoa(value) }} /> 이상
                                </td><td>
                                {/* <Button type="primary" onClick={() => handleRiskDoa()} loading={isLoading}> */}
                                <Button type="primary" onClick={() => onClickConfigMod("doa")} loading={isLoading}>
                                        DOA 설정
                                </Button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="section">
                    <table className='search_config' style={{position: "relative", left: "60px", backgroundColor: "white", width: "650px" }}>
                        <colgroup>
                            <col style={{ width: '120px' }} />
                            <col style={{ width: '380px' }} />
                            <col style={{ width: '100px' }} />
                        </colgroup>
                        <tbody>
                            <tr>
                                <td colSpan={3}>
                                    <div style={{ position: "relative", fontSize: "16px", left: "-12px", top: "10px" }}>
                                        PC 진단 설정 &nbsp;
                                        {/* <a href="#" data="sl" onClick={menualPopup}><QuestionCircleOutlined /></a> */}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th style={{ backgroundColor: 'white', textAlign: "left" }}>
                                    <span className='req'>*</span>Version
                                </th>
                                <td>
                                    <Input addonBefore="APP" placeholder="2.2.2" value={appVersion} className="configvalue-input"
                                    onChange={(e) => { setAppVersion(e.target.value) }} />
                                </td>
                                <td rowSpan={4}>
                                <Button type="primary" onClick={() => onClickConfigMod("auto")} loading={isLoading}>
                                    PC진단 설정
                                </Button>
                                </td>
                                {/* <td>
                                <Button type="primary" onClick={() => onClickConfigMod("appVersion")} loading={isLoading}>
                                    버전 설정
                                </Button>
                                </td> */}
                            </tr>
                            {/* <tr>
                                <th style={{ backgroundColor: 'white', textAlign: "left" }}>
                                    사용여부
                                </th><td>
                                    <Select defaultValue="미사용" options={options}  onChange={(value,obj) => { console.log(obj); setAppUse(value); }} style={{width:"100px"}}/>
                                </td>
                                <td>
                                <Button type="primary" onClick={() => onClickConfigMod("appUse")} loading={isLoading}>
                                    사용 설정
                                </Button>
                                </td>
                            </tr> */}
                            
                            <tr>
                                <th style={{ backgroundColor: 'white', textAlign: "left" }}>
                                    업데이트 경로
                                </th>
                                <td>
                                    <Input addonBefore="URL" placeholder="input text" value={appUrl} className="configvalue-input" onChange={(e) => { setAppUrl(e.target.value) }}  allowClear />

                                </td>
                                {/* <td>
                                <Button type="primary" onClick={() => onClickConfigMod("appUrl")} loading={isLoading}>
                                    경로 설정
                                </Button>
                                </td> */}
                            </tr>
                            
                            <tr>
                                <th style={{ backgroundColor: 'white', textAlign: "left" }}>
                                    예약 설정
                                </th>
                                <td>    
                                    <DatePicker
                                        style={{ padding: "2px 6px" }}
                                        format="YYYY-MM-DD HH:mm:ss"
                                        showTime={{
                                            defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                                        }}

                                        value={appAutoDate && dayjs(Number(appAutoDate))} onChange={onDateChange}
                                    /> <br/>최대 10분 정도 늦게 적용될 수 있습니다.
                                    {/* <DatePicker style={{ padding: "2px 5px" }} value={appAutoDate ? dayjs(appAutoDate) : null} onChange={onDateChange} /> &nbsp;
                                    <TimePicker placeholder="Hour" hourStep={1} format={'HH'} value={appAutoHour ? dayjs(appAutoHour, 'HH') : null} onChange={onHourChange} style={{ padding: "2px 5px", width: "90px" }} /> &nbsp;
                                    <TimePicker placeholder="Minu" minuteStep={10} format={'mm'} value={appAutoMinu ? dayjs(appAutoMinu, 'mm') : null} onChange={onMinuChange} style={{ padding: "2px 5px", width: "90px" }} /> */}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="section">
                    <table className='search_config' style={{position: "relative", left: "60px", backgroundColor: "white", width: "650px" }}>
                        <colgroup>
                            <col style={{ width: '120px' }} />
                            <col style={{ width: '120px' }} />
                            <col style={{ width: '120px' }} />
                            <col style={{ width: '120px' }} />
                        </colgroup>
                        <tbody>
                            <tr>
                                <td colSpan={4}>
                                    <div style={{ position: "relative", fontSize: "16px", left: "-15px", top: "10px" }}>
                                        라이센스 정보 &nbsp;
                                        {/* <a href="#" data="sl" onClick={menualPopup}><QuestionCircleOutlined /></a> */}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th style={{ backgroundColor: 'white', textAlign: "left" }}>
                                    <span className='a'>라이센스 만료일</span>
                                </th>
                                <td colSpan="3">
                                    <span>{licenseDate}</span>
                                </td>
                            </tr>                       
                            <tr>
                                <th style={{ backgroundColor: 'white', textAlign: "left" }}>
                                    <span className='q'>점검 혀용된 PC 수</span>
                                </th>
                                <td>
                                    <span>{pcLimit}</span>
                                </td>
                                <th style={{ backgroundColor: 'white', textAlign: "left" }}>
                                    <span className='q'>점검된 PC 수</span>
                                </th>
                                <td>
                                    <span>{pcUsed}</span>
                                </td>
                            </tr>
                            <tr>
                                <th style={{ backgroundColor: 'white', textAlign: "left" }}>
                                    <span className='q'>점검 허용된 서버 수</span>
                                </th>
                                <td>
                                    <span>{serverLimit}</span>
                                </td>
                                <th style={{ backgroundColor: 'white', textAlign: "left" }}>
                                    <span className='q'>점검된 서버 수</span>
                                </th>
                                <td>
                                    <span>{serverUsed}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="section">
                    <table className='search_config' style={{position: "relative", left: "60px", backgroundColor: "white", width: "650px" }}>
                        <colgroup>
                            <col style={{ width: '120px' }} />
                            <col style={{ width: 'auto' }} />
                        </colgroup>
                        <tbody>
                            <tr>
                                <td colSpan={2}>
                                    <div style={{ position: "relative", fontSize: "16px", left: "-15px", top: "10px" }}>
                                        권한 정보 &nbsp;
                                    </div>
                                </td>
                            </tr>
                            {permissions && permissions.user ? (
                                <>
                                    <tr>
                                        <th style={{ backgroundColor: 'white', textAlign: "left" }}>
                                            <span className='q'>사용자 정보</span>
                                        </th>
                                        <td>
                                            <span>
                                                <strong>ID:</strong> {permissions.user.username || '-'} &nbsp;&nbsp;
                                                <strong>이름:</strong> {permissions.staff_info?.name || '-'} &nbsp;&nbsp;
                                                <strong>회사:</strong> {permissions.company ? `${permissions.company.name} (${permissions.company.code})` : '-'}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style={{ backgroundColor: 'white', textAlign: "left" }}>
                                            <span className='q'>권한 상태</span>
                                        </th>
                                        <td>
                                            <span>
                                                <strong>시스템 관리자:</strong> {permissions.user.is_superuser ? '예' : '아니오'} &nbsp;&nbsp;
                                                <strong>스태프:</strong> {permissions.user.is_staff ? '예' : '아니오'}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style={{ backgroundColor: 'white', textAlign: "left" }}>
                                            <span className='q'>허용된 기능</span>
                                        </th>
                                        <td style={{ maxWidth: '500px' }}>
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                                {permissions.permissions?.feature_details?.length > 0 ? permissions.permissions.feature_details.map((f, index) => <Tag key={index} color="blue" style={{ borderRadius: '10px', padding: '2px 12px', marginBottom: '4px' }}>{f.name}</Tag>) : <span>-</span>}
                                            </div>
                                        </td>
                                    </tr>
                                </>
                            ) : (
                                <tr>
                                    <td colSpan={2} style={{ textAlign: "center", padding: "20px" }}>
                                        권한 정보를 불러오는 중...
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>


            </td></tr></tbody></table> 
        </>
    );
}

export default ConfigValue;